/** String discriminant for a top-level tab. */
export type TabKey = 'route' | 'departures';

const KNOWN: readonly TabKey[] = ['route', 'departures'];

/** True when `candidate` is one of the known {@link TabKey} strings. */
export function isTabKey(candidate: string): candidate is TabKey {
  return (KNOWN as readonly string[]).includes(candidate);
}

/**
 * Reactive holder for the currently-active tab. Instantiate a fresh copy per
 * test to isolate state; the app has exactly one instance under `app.svelte`.
 */
export class TabStore {
  active = $state<TabKey>('route');

  /** Sets `active` if `keyName` is a known tab; ignores any other input. */
  activate(keyName: string): void {
    if (isTabKey(keyName)) this.active = keyName;
  }
}
